export default "__VITE_ASSET__CP5Gqukp__"